export type CustomPaletteColor = {
  50?: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  1000: string;
  DEFAULT: string;
};

export interface Palette {
  coral: string;
  lightCoral: string;
  darkPurple: string;
  gray: string;
  backgroundGray: string;
  darkGray: string;
  lightGray: string;
  ultraLightGray: string;
  black: string;
  purple: string;
  lightPurple: string;
  white: string;
  shadow: string;
  disabled: string;
  tomato: string;
  green: string;
  lightGreen: string;
  brandPurple: CustomPaletteColor;
  brandMaroon: CustomPaletteColor;
  borders: {
    main: string;
  };
}

const brandPurple: CustomPaletteColor = {
  100: '#EBEBEE',
  200: '#D7D6DD',
  300: '#AFADBB',
  400: '#888598',
  500: '#605C76',
  600: '#383354',
  700: '#2D2943',
  800: '#221F32',
  900: '#161422',
  1000: '#0B0A11',
  DEFAULT: '#383354',
};

// Peu utilisé (EmergencyNotice uniquement)
const brandMaroon: CustomPaletteColor = {
  100: '#F3EBEB',
  200: '#E7D6D6',
  300: '#CFADAD',
  400: '#B88585',
  500: '#A05C5C',
  600: '#883333',
  700: '#6D2929',
  800: '#521F1F',
  900: '#361414',
  1000: '#1B0A0A',
  DEFAULT: '#F3EBEB',
};

export const colors = {
  coral: '#fa5447',
  lightCoral: '#FEEEED', // Peu utilisé (palette uniquement)
  darkPurple: '#383354',
  darkGray: '#666666',
  gray: '#9e9cac',
  lightGray: '#F5F5F5',
  backgroundGray: '#E2E2E2',
  ultraLightGray: '#F5F6F8',
  black: '#363636',
  purple: '#7161ef',
  lightPurple: '#F6F5FD',
  white: '#ffffff',
  shadow: 'rgba(54, 54, 54, 0.2)',
  error: '#D8000C',
  success: '#18C5B4',
  green: '#5E9DA3', // Peu utilisé (palette uniquement)
  lightGreen: '#F4F8F9', // Peu utilisé (palette uniquement)
  disabled: 'gray',
  brandPurple,
  brandMaroon,
  tomato: '#883333', // Peu utilisé (palette uniquement)
};

// Utilisé uniquement dans apps/patient (tailwind.config.ts)
export const tailwindThemeColors = {
  primary: colors.darkPurple,
  secondary: '#2C1696',
  tertiary: colors.purple,
};

export const appTheme = {
  palette: {
    ...colors,
    primary: {
      main: colors.darkPurple,
      light: colors.purple,
    },
    secondary: {
      main: '#2C1696',
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
    warning: {
      main: colors.coral,
    },
    borders: {
      main: colors.brandPurple[200],
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
};
